import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Button } from '../Buttons';

const Modal = ({
  open,
  onConfirm,
  onClose,
  title,
  titleIcon,
  children,
  dialogClassName,
  maxWidth = 'md',
  fullScreen = false,
  primaryButton = { text: 'confirm', hidden: false },
  secondaryButton = { text: 'cancel', hidden: false },
  showCloseButton = false,
  ...rest
}) => {
  const handleClose = (event, reason) => {
    onClose?.(event, reason);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={maxWidth} fullScreen={fullScreen} {...rest}>
      {title && (
        <DialogTitle>
          {titleIcon}
          {title}
          {showCloseButton && (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {!secondaryButton.hidden && (
            <Button
              onClick={handleClose}
              variant={secondaryButton.variant ?? 'secondary'}
              color={secondaryButton.color ?? 'secondary'}
              disabled={secondaryButton.disabled}
              sx={secondaryButton.sx}
            >
              {secondaryButton.text}
            </Button>
          )}
        </div>
        {!primaryButton.hidden && (
          <Button
            onClick={onConfirm}
            variant={primaryButton.variant ?? 'primary'}
            color={primaryButton.color ?? 'primary'}
            disabled={primaryButton.disabled}
            sx={primaryButton.sx}
          >
            {primaryButton.text}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
